export default __webpack_public_path__ + "static/media/passwordBackground.d3ebdafc.svg";